import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { RouteRecoveryPage } from './routes/RouteRecoveryPage';
import { queryClient } from './app/queryClient';
import { AuthProvider } from './features/auth/AuthProvider';
import { UserPreferencesProvider } from './features/settings/UserPreferencesProvider';
import { PortalSessionBoundary } from './features/portal/PortalSessionBoundary';
import './styles/globals.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root not found in index.html');
}

// Preserve App's existing route tree while enabling supported navigation blockers,
// including browser Back/Forward, for forms with private local drafts.
const router = createBrowserRouter([
  {
    path: '*',
    errorElement: <RouteRecoveryPage />,
    element: (
      <AuthProvider>
        <UserPreferencesProvider>
          <PortalSessionBoundary>
            <App />
          </PortalSessionBoundary>
        </UserPreferencesProvider>
      </AuthProvider>
    ),
  },
]);

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
